<h3>Sent Emails</h3>
<p>Emails we sent to this player for this game, plus emails that belong to no game. Click a row to see what was sent.</p>

<form [formGroup]="filterFormGroup">
  <div class="flex-row-wrap justify-space-between">
    <mat-form-field appearance="outline" class="flex-50">
      <mat-label>Kind</mat-label>
      <mat-select placeholder="Any kind" formControlName="emailTemplateTypeId" data-testid="sent-emails-kind-select">
        <mat-option [value]="null">Any kind</mat-option>
        @for (type of emailTemplateTypes; track type.Value) {
          <mat-option [value]="type.Value">{{ type.Name }}</mat-option>
        }
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" class="flex-50">
      <mat-label>Status</mat-label>
      <mat-select placeholder="Any status" formControlName="status" data-testid="sent-emails-status-select">
        <mat-option [value]="null">Any status</mat-option>
        @for (status of statusOptions; track status.value) {
          <mat-option [value]="status.value">{{ status.name }}</mat-option>
        }
      </mat-select>
    </mat-form-field>

    <mat-form-field class="flex-50" appearance="outline">
      <mat-label>Date Range</mat-label>
      <mat-date-range-input [rangePicker]="rangePicker">
        <input matStartDate placeholder="From" formControlName="fromDate" data-testid="sent-emails-from-date-input">
        <input matEndDate placeholder="To" formControlName="toDate" data-testid="sent-emails-to-date-input">
      </mat-date-range-input>
      <mat-hint>MM-DD-YYYY – MM-DD-YYYY</mat-hint>
      <mat-datepicker-toggle matSuffix [for]="rangePicker"></mat-datepicker-toggle>
      <mat-date-range-picker #rangePicker></mat-date-range-picker>
    </mat-form-field>
  </div>
</form>

<div class="text-end">
  <button mat-raised-button class="margin-right-small" color="primary" (click)="onFilterClick()"
          data-testid="sent-emails-filter-button">Filter</button>
  <button mat-raised-button (click)="onResetClick()" data-testid="sent-emails-reset-button">Reset</button>
</div>

@if (filter) {
  <app-email-audit-table [filter]="filter"></app-email-audit-table>
}
